var _style, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes drawPath {\n      0% {\n        stroke-dashoffset: 400;\n        opacity: 0.3;\n      }\n      50% {\n        stroke-dashoffset: 0;\n        opacity: 1;\n      }\n      100% {\n        stroke-dashoffset: -400;\n        opacity: 0.3;\n      }\n    }\n\n    @keyframes pulseStar {\n      0%,\n      100% {\n        transform: scale(1);\n        opacity: 0.8;\n      }\n      50% {\n        transform: scale(1.2);\n        opacity: 1;\n      }\n    }\n\n    .loading-path {\n      stroke-dasharray: 400;\n      animation: drawPath 3s linear infinite;\n    }\n\n    .star-1 {\n      transform-box: fill-box;\n      transform-origin: center;\n      animation: pulseStar 1.5s ease-in-out infinite;\n    }\n\n    .star-2 {\n      transform-box: fill-box;\n      transform-origin: center;\n      animation: pulseStar 1.5s ease-in-out infinite 0.75s;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "star-1",
    d: "M11.6693 36.6667L13.3359 30L20.0026 28.3333L13.3359 26.6667L11.6693 20L10.0026 26.6667L3.33594 28.3333L10.0026 30L11.6693 36.6667Z",
    fill: "url(#paint0_linear_17098_38643)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "star-2",
    d: "M50.0026 30L53.1359 23.1L60.0026 20L53.1359 16.9L50.0026 10L46.9359 16.9L40.0026 20L46.9359 23.1L50.0026 30Z",
    fill: "url(#paint0_linear_17098_38643)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "loading-path",
    d: "M10 60L33.3333 36.6667L50 53.3333L70 33.3333",
    pathLength: 400,
    stroke: "#4D4D4D",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 60,
    r: 6.6667,
    fill: "#4D4D4D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3333,
    cy: 36.6667,
    r: 6.6667,
    fill: "#4D4D4D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 53.3333,
    r: 6.6667,
    fill: "#4D4D4D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 33.3333,
    r: 6.6667,
    fill: "#4D4D4D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17098_38643",
    x1: 78.2711,
    y1: 69.6997,
    x2: -5.93419,
    y2: 31.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#0CF7CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC0DE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.58317231959b7ca4c6f64e5ed47d9803.svg";
export { ForwardRef as ReactComponent };